/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TrainingMaterialsMainPageComponent} from './training-materials-main-page/training-materials-main-page.component';
import {RoutingMenuItemModel} from '../shared/utils/routing-menu-item.model';
import {Permission} from '../shared/utils/permission.enum';
import {PermissionsGuard} from '../permissions.guard';

export const routes: Routes = [
    {
        path: 'training-materials',
        canActivate: [PermissionsGuard],
        canActivateChild: [PermissionsGuard],
        data: {
            hasSideBarMenu: true,
            breadcrumb: 'Training Materials',
            permissions: [
                Permission.PARTNER_SPO_VIEW,
                Permission.PARTNER_CLAIM_VIEW,
                Permission.ADMIN_SPO_VIEW,
                Permission.ADMIN_CLAIM_VIEW,
                Permission.ADMIN_PNC_VIEW,
                Permission.PARTNER_PNC_VIEW,
                Permission.PRICE_PLANNER_PNC_VIEW,
                Permission.PLANNER_PNC_VIEW,
                Permission.TECHNICIAN_PNC_VIEW,
                Permission.EE_SPECIALIST_PNC_VIEW
            ],
            menuItem: {
                label: 'Training Materials',
                icon: 'iwp-icon-test_doc',
                index: 7
            } as RoutingMenuItemModel
        },
        children: [
            {
                path: '',
                component: TrainingMaterialsMainPageComponent,
                data: {
                    hasSideBarMenu: true,
                    hasStickyHeader: true,
                    permissions: [
                        Permission.PARTNER_SPO_VIEW,
                        Permission.PARTNER_CLAIM_VIEW,
                        Permission.ADMIN_SPO_VIEW,
                        Permission.ADMIN_CLAIM_VIEW,
                        Permission.ADMIN_PNC_VIEW,
                        Permission.PARTNER_PNC_VIEW,
                        Permission.PRICE_PLANNER_PNC_VIEW,
                        Permission.PLANNER_PNC_VIEW,
                        Permission.TECHNICIAN_PNC_VIEW,
                        Permission.EE_SPECIALIST_PNC_VIEW
                    ]
                }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TrainingMaterialsRoutingModule {
}

